import {tokens, radii} from '@commercial-helios/ui/theme'
import React from 'react'
import ContentLoader from 'react-content-loader'
import styled from 'styled-components'

import useMediaQuery from '@helios/shared/hooks/use-media-query'
import mq from '@helios/shared/utils/media-query'

const loadingColors = {
    backgroundColor: tokens.shade200,
    foregroundColor: tokens.shade300,
}

interface LoadingProps {
    backgroundColor?: string
    foregroundColor?: string
}

const Loading = () => {
    const isSmallScreen = useMediaQuery.max('sm')
    return (
        <LoadingPlaceholder>
            {isSmallScreen ? (
                <LoadingInfoBoxMobile {...loadingColors} />
            ) : (
                <LoadingInfoBox {...loadingColors} />
            )}

            <StatusBoxWrapper>
                <InvoiceStatusContainer>
                    <LoadingInvoiceStatus {...loadingColors} />
                </InvoiceStatusContainer>
                <LoadingSingleLine {...loadingColors} />
            </StatusBoxWrapper>
        </LoadingPlaceholder>
    )
}

const LoadingPlaceholder = styled.div`
    display: grid;
    gap: ${tokens.spacing20};

    ${mq.min('sm')} {
        grid-template-columns: repeat(2, 1fr);
    }
`

const InvoiceStatusContainer = styled.div`
    display: grid;
    max-width: 100%;
    padding: ${tokens.spacing24};
    overflow: hidden;
    background: ${tokens.shade100};
    row-gap: ${tokens.spacing48};
    column-gap: ${tokens.spacing40};
    border-radius: ${radii.arc20};

    ${mq.min('sm')} {
        border-radius: ${radii.arc8};
    }
`

const StatusBoxWrapper = styled.div`
    display: grid;
    gap: ${tokens.spacing28};
`

/**
 * Loading components generated by https://skeletonreact.com/
 * Don't edit manually, use the website's editor instead
 */

const LoadingInfoBox = ({...props}: LoadingProps) => (
    <ContentLoader
        speed={2}
        width={400}
        height={460}
        viewBox="0 0 400 460"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <rect rx="4" ry="4" x="0" y="40" width="317" height="72" />
        <rect rx="4" ry="4" x="0" y="134" width="219" height="48" />
        <rect rx="4" ry="4" x="0" y="204" width="89" height="24" />
        <rect rx="4" ry="4" x="0" y="236" width="165" height="24" />
        <rect rx="4" ry="4" x="0" y="292" width="89" height="24" />
        <rect rx="4" ry="4" x="0" y="324" width="165" height="24" />
        <rect rx="4" ry="4" x="250" y="292" width="89" height="24" />
        <rect rx="4" ry="4" x="250" y="324" width="165" height="24" />
    </ContentLoader>
)

const LoadingInfoBoxMobile = ({...props}: LoadingProps) => (
    <ContentLoader
        speed={2}
        width={327}
        height={460}
        viewBox="0 0 327 460"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <rect rx="4" ry="4" x="0" y="40" width="317" height="72" />
        <rect rx="4" ry="4" x="0" y="134" width="219" height="48" />
        <rect rx="4" ry="4" x="0" y="204" width="89" height="24" />
        <rect rx="4" ry="4" x="0" y="236" width="165" height="24" />
        <rect rx="4" ry="4" x="0" y="292" width="89" height="24" />
        <rect rx="4" ry="4" x="0" y="324" width="165" height="24" />

        <rect rx="4" ry="4" x="0" y="364" width="89" height="24" />
        <rect rx="4" ry="4" x="0" y="396" width="165" height="24" />
    </ContentLoader>
)

const LoadingInvoiceStatus = ({...props}: LoadingProps) => (
    <ContentLoader
        speed={2}
        width={415}
        height={380}
        viewBox="0 0 415 380"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        style={{maxWidth: '100%'}}
        {...props}
    >
        <rect rx="4" ry="4" x="0" y="0" width="145" height="24" />
        <rect rx="4" ry="4" x="0" y="34" width="415" height="24" />
        <rect rx="4" ry="4" x="0" y="130" width="415" height="242" />
    </ContentLoader>
)

const LoadingSingleLine = ({...props}: LoadingProps) => (
    <ContentLoader
        speed={2}
        width={327}
        height={460}
        viewBox="0 0 327 460"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <rect rx="4" ry="4" x="0" y="0" width="308" height="16" />
    </ContentLoader>
)

export default Loading
